var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#0A89E0;}\n\t.st2{display:inline;fill:#53ADF8;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#53ADF8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,18C1,22.2,1,29.1,5.1,33.4l24.5,25.4l1.6,1.7l0,0c2,2.1,4.7,3.2,7.4,3.2s5.4-1.1,7.4-3.2l6.2-6.4 c1.4-1.4,1.4-3.7,0-5.1c-1.4-1.4-3.6-1.4-4.9,0l-6.2,6.4c-1.4,1.4-3.6,1.4-5,0l0,0L10,28.4c-1.4-1.4-1.4-3.7,0-5.1l12.4-12.8 c1.4-1.4,3.6-1.4,5,0L38.7,22c1.4,1.4,3.6,1.4,4.9,0c1.4-1.4,1.4-3.7,0-5.1L32.3,5.2C28.2,1,21.5,1,17.5,5.2L5.1,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.4,69c-1.4,1.4-1.4,3.7,0,5.1l11.3,11.7c2,2.1,4.7,3.2,7.4,3.2s5.4-1.1,7.4-3.2L82.9,73 c4.1-4.2,4.1-11.1,0-15.4l-26.1-27c-4.1-4.2-10.8-4.2-14.8,0L35.8,37c-1.4,1.4-1.4,3.7,0,5.1c1.4,1.4,3.6,1.4,4.9,0l6.2-6.4 c1.4-1.4,3.6-1.4,5,0l26.1,27c1.4,1.4,1.4,3.7,0,5.1L65.6,80.7c-1.4,1.4-3.6,1.4-5,0L49.3,68.9C48,67.5,45.8,67.5,44.4,69z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,30.4c0-2.5,1.8-4.5,4-4.5s4,2,4,4.5v22.5c0,2.5-1.8,4.5-4,4.5H33.1c-2.2,0-4-2-4-4.5s1.8-4.5,4-4.5h10 L13.3,14.1c-1.5-1.8-1.5-4.5,0-6.3c0.8-0.9,1.8-1.4,2.9-1.4s2.1,0.5,2.9,1.4l29.4,33.9V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.2,38.1c2.2,0,4,2,4,4.5v9.3c0,10.7,1.7,17.6,5.4,21.9C18.3,78,24.3,80,33.5,80h24.2c9.2,0,15.1-2,18.8-6.2 c3.7-4.3,5.4-11.2,5.4-21.9v-9.4c0-0.4,0.1-0.8,0.2-1.2c-0.1-0.4-0.2-0.8-0.2-1.2c0-10.7-1.7-17.6-5.4-21.9 C72.8,14,66.9,12,57.7,12h-8.1c-2.2,0-4-2-4-4.5s1.8-4.5,4-4.5h8.1C69.2,3,77,5.8,82.3,11.9c5.2,6.1,7.7,15,7.7,28.2 c0,0.4-0.1,0.8-0.2,1.2c0.1,0.4,0.2,0.8,0.2,1.2v9.4c0,13.2-2.4,22.1-7.7,28.2C77,86.2,69.2,89,57.7,89H33.5 C22,89,14.2,86.2,8.9,80.1c-5.2-6.1-7.7-15-7.7-28.2v-9.3C1.2,40.1,3,38.1,5.2,38.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.9,30.7c0-1.9-0.7-3.6-2-4.9C73.8,21.7,60.3,8.2,56.3,4.2c-1.3-1.3-3.1-2-4.9-2c-5.1,0-20.6,0-30.3,0 c-2.9,0-5.7,1.2-7.8,3.2c-2.1,2.1-3.2,4.9-3.2,7.8v63.8c0,2.9,1.2,5.7,3.2,7.8c2.1,2.1,4.9,3.2,7.8,3.2h47.9c6.1,0,11-4.9,11-11 V30.7z M73.9,30.7v46.2c0,2.8-2.2,5-5,5H21.1c-1.3,0-2.6-0.5-3.5-1.5c-0.9-0.9-1.5-2.2-1.5-3.5V13.1c0-1.3,0.5-2.6,1.5-3.5 c0.9-0.9,2.2-1.5,3.5-1.5h30.3c0.3,0,0.5,0.1,0.7,0.3L73.6,30C73.8,30.2,73.9,30.4,73.9,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50,7.1v14c0,6.1,4.9,11,11,11h14c1.7,0,3-1.3,3-3s-1.3-3-3-3H61c-2.8,0-5-2.2-5-5v-14c0-1.7-1.3-3-3-3 C51.3,4.1,50,5.5,50,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42,43v19.9c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3V43c0-1.7-1.3-3-3-3C43.3,40,42,41.4,42,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35,56H55c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3H35c-1.7,0-3,1.3-3,3C32,54.6,33.4,56,35,56z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.2,74.4c0.3,0,0.6,0,0.9-0.1l19.3-4.5c0.8-0.2,1.5-0.6,2-1.1l32.2-32.2c0,0,0,0,0.1,0c0,0,0,0,0-0.1l9-9 c2.4-2.4,3.7-5.5,3.7-8.9s-1.3-6.5-3.7-8.9l-3-3c-4.8-4.8-13.1-4.8-17.8,0l-9,9c0,0,0,0,0,0c0,0,0,0,0,0L8.7,47.9 c-0.6,0.6-0.9,1.3-1.1,2L3.1,69.2c-0.3,1.4,0.1,2.9,1.1,3.9C5,73.9,6.1,74.4,7.2,74.4z M55.9,12.5c1.6-1.6,4.4-1.6,5.9,0l3,3 c0.8,0.8,1.2,1.8,1.2,3s-0.4,2.2-1.2,3l-6.1,6.1l-8.9-8.9L55.9,12.5z M87,82.8c0,2.3-1.9,4.2-4.2,4.2H7.2C4.9,87,3,85.1,3,82.8 s1.9-4.2,4.2-4.2h75.7C85.1,78.6,87,80.4,87,82.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/Create.3179bf2440f0bcecc1ce98c6283b8f3c.svg";
export { ForwardRef as ReactComponent };